import React from "react";
import { Table } from "../components/Table";

const TablePage = () => {
  return (
    <>
      <Table />
    </>
  );
};

export default TablePage;
